<template>
    <div class="journey-assignment-details">
        <div v-if="item.target_type === 'object_group'">
            Текущий состав группы:
            <ul v-if="item.group_objects && item.group_objects.length">
                <li v-for="object in item.group_objects" :key="object.building_id">{{ object.name }}</li>
            </ul>
            <span v-else>нет доступных объектов.</span>
        </div>
        <template v-for="plan in plans">
            <div :key="plan.id">
                <div v-if="plan.matches_assignment">{{ planState(plan) }}</div>
                <div v-for="period in plan.plan_periods" :key="period.id">
                    {{ formatDate(period.date) }}<template v-if="period.end_date"> — {{ formatDate(period.end_date) }}</template>
                    <span v-if="period.author"> · {{ period.author }}</span>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import {formatDate, planState} from './employeeJourneyPresentation';
export default {
    name: 'EmployeeJourneyAssignmentDetails',
    props: {item: {type: Object, required: true}},
    computed: {plans() { return this.item.plans || (this.item.plan_periods ? [this.item] : []); }},
    methods: {formatDate, planState}
};
</script>

<style scoped>
.journey-assignment-details { color: #617486; margin-top: 6px; overflow-wrap: anywhere; }
.journey-assignment-details ul { padding-left: 18px; margin-bottom: 6px; }
</style>
